<div class="a00030">
    <a [href]="link" [attr.target]="target" class="text">{{ text }}</a>
</div>
